import { useEffect, useState } from "react";
import styles from "../../../styles/components/Sections.module.css";
import Toggle from "../../../ui/selectors/Toggle";
import { useAuth } from "../../../contexts/AuthContext";

const NotificationsSection = () => {
  const { auth, updateNotifications } = useAuth();

  const [notificationsEnabled, setNotificationsEnabled] = useState(
    auth?.user?.notifications_enabled ?? true,
  );


  useEffect(() => {
    setNotificationsEnabled(auth?.user?.notifications_enabled ?? true);
  }, [auth?.user?.notifications_enabled]);

  const handleToggle = async (newValue) => {
    if (typeof updateNotifications !== "function") {
      console.error("updateNotifications no está disponible en AuthContext");
      return;
    }

    setNotificationsEnabled(newValue);

    try {
      await updateNotifications(newValue);
    } catch (error) {
      setNotificationsEnabled(!newValue);
      console.error("Error al actualizar notificaciones:", error);
    }
  };

  return (
    <div className={styles.sectionContent}>
      <div className={styles.block}>
        <div className={styles.blockTitle}>Ajustes</div>

        <div className={styles.toggleRow}>
          <div className={styles.toggleLabel}>
            Enviar todas las notificaciones
          </div>

          <Toggle
            checked={notificationsEnabled}
            onChange={handleToggle}
            ariaLabel="Activar notificaciones"
          />
        </div>
      </div>
    </div>
  );
};

export default NotificationsSection;
